import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
import { Studio } from '@/modules/Studios/types'
import GmapsPlaceInput from '@/components/GmapsPlaceInput.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateStudioLocation',
  props: {
    studio: null
  },
  setup(__props: any) {

const props = __props as {
  studio: Studio
};



const location = ref({
  address: props.studio.locationAddress || '',
  lat: props.studio.locationLat || 0,
  lng: props.studio.locationLng || 0,
})

watch(
  () => location.value,
  (value) => {
    props.studio.locationAddress = value.address
    props.studio.locationLat = value.lat
    props.studio.locationLng = value.lng
  },
  { deep: true }
)

return { __sfc: true,props, location, GmapsPlaceInput }
}

})